// extracted by mini-css-extract-plugin
export default {"segment_name_label":"SegmentName_segment_name_label__CFGOz","segment_container":"SegmentName_segment_container__j9+OE","fadeInOut":"SegmentName_fadeInOut__SkxgL"};